import formatDuration from '../../../../helpers/date-time/format-duration'
import type { ShipmentColumn } from '../../types/column-types'
import { onCellStandard } from '../../helpers/helpers'
import { renderShipmentCalculated } from '../../helpers/render-shipment-calculated'
import { isShipmentCalculatedOnActual } from '../../../../helpers/entities/shipment/get-shipment-display-calculated'
import { CaretDownFilled, CaretUpFilled } from '@ant-design/icons'
import { green, red } from '@ant-design/colors'

export const timeGroupColumn: ShipmentColumn = {
    key: 'time',
    title: 'Время',
    // @ts-ignore
    children: [
        {
            key: 'printingTime',
            dataIndex: ['calculated', 'printingTime'],
            title: 'Время на тираж',
            width: 80,
            onCell: onCellStandard,
            render: renderShipmentCalculated(calculated =>
                formatDuration(calculated?.printingTime || 0)
            ),
        },
        {
            key: 'finishingTime',
            dataIndex: ['calculated', 'finishingTime'],
            title: 'Время на отделку',
            width: 80,
            onCell: onCellStandard,
            render: renderShipmentCalculated(calculated =>
                formatDuration(calculated?.finishingTime || 0)
            ),
        },
        {
            key: 'commonTime',
            dataIndex: ['calculated', 'commonTime'],
            title: 'Общее время',
            width: 80,
            onCell: onCellStandard,
            render: renderShipmentCalculated((calculated, shipment) => {
                const value = formatDuration(calculated?.commonTime || 0)
                if (shipment.shipmentType !== 'label' || !isShipmentCalculatedOnActual(shipment)) {
                    return value
                }
                const planned = shipment.calculated?.commonTime ?? 0
                const actual = shipment.calculatedOnActual?.commonTime ?? 0
                const difference = actual - planned
                if (difference === 0) return value
                return (
                    <>
                        {value}{' '}
                        {difference < 0 ? <CaretDownFilled style={{ color: green[5] }} /> : <CaretUpFilled style={{ color: red[5] }} />}
                    </>
                )
            }),
        },
    ],
}
